import { loginStatus } from 'utils/constants/status';
import { EVENT_MAP_ICON_TYPE } from 'utils/constants/Map';
import { ROLES, PAGE_URLS, PAGE_NAME } from 'utils/constants';
import { getLocation } from 'utils/DataTransform/Events/eventReportList';
import isEmpty from 'lodash/isEmpty';
import { TASK_TYPE } from 'utils/constants/task';
import { serviceTypes } from 'utils/constants/serviceTypes.js';
import get from 'lodash/get';
import COLORS from 'utils/constants/colors';

export const acceptedPersonnelStatus = [
  loginStatus.AVAILABLE,
  loginStatus.ON_INTERRUPTABLE_TASK,
  loginStatus.NOT_LOGGED_IN,
  loginStatus.ON_TASK,
  loginStatus.UNAVAILABLE,
  loginStatus.ON_BREAK,
];
export const allEventMarkerWithPointLoc = [
  EVENT_MAP_ICON_TYPE.NEWS_EVENT_SINGLE_LOC,
  EVENT_MAP_ICON_TYPE.NON_NEWS_EVENT_SINGLE_LOC,
  EVENT_MAP_ICON_TYPE.NEWS_EVENT_MULTI_LOC,
  EVENT_MAP_ICON_TYPE.NON_NEWS_EVENT_MULTI_LOC,
];
export const allEventMarkerWithPolygon = [
  EVENT_MAP_ICON_TYPE.NEWS_EVENT_POLYGON,
  EVENT_MAP_ICON_TYPE.NON_NEWS_EVENT_POLYGON,
];
export const allEventsWithEllipse = [
  EVENT_MAP_ICON_TYPE.NEWS_EVENT_ELLIPSE,
  EVENT_MAP_ICON_TYPE.NON_NEWS_EVENT_ELLIPSE,
];
export const allEventMarkerIcon = [
  ...allEventMarkerWithPointLoc,
  ...allEventMarkerWithPolygon,
  ...allEventsWithEllipse,
];
export const allPersonnelMarkerIcon = [
  ROLES.RESPONDER.name.toLowerCase(),
  ROLES.GUARD.name.toLowerCase(),
  ROLES.OPERATOR.name.toLowerCase(),
  ROLES.CLEANER.name.toLowerCase(),
  ROLES.MAINTAINER.name.toLowerCase(),
];

export const getEventIcon = event => {
  if (event.locations[0].point) {
    if (event.locations.length === 1) {
      if (event.general.isNewsItem) {
        return EVENT_MAP_ICON_TYPE.NEWS_EVENT_SINGLE_LOC;
      } else {
        return EVENT_MAP_ICON_TYPE.NON_NEWS_EVENT_SINGLE_LOC;
      }
    } else if (event.locations.length > 1) {
      if (event.general.isNewsItem) {
        return EVENT_MAP_ICON_TYPE.NEWS_EVENT_MULTI_LOC;
      } else {
        return EVENT_MAP_ICON_TYPE.NON_NEWS_EVENT_MULTI_LOC;
      }
    }
  } else if (event.locations[0].polygon) {
    if (event.general.isNewsItem) {
      return EVENT_MAP_ICON_TYPE.NEWS_EVENT_POLYGON;
    } else {
      return EVENT_MAP_ICON_TYPE.NON_NEWS_EVENT_POLYGON;
    }
  } else if (event.locations[0].ellipse) {
    if (event.general.isNewsItem) {
      return EVENT_MAP_ICON_TYPE.NEWS_EVENT_ELLIPSE;
    } else {
      return EVENT_MAP_ICON_TYPE.NON_NEWS_EVENT_ELLIPSE;
    }
  }
  //default
  return EVENT_MAP_ICON_TYPE.NON_NEWS_EVENT_SINGLE_LOC;
};

//deciding based on the locations
export const convertEventToMarkers = ({
  events,
  selectedEvent,
  handleEventPolygonClick,
}) => {
  return events.reduce((previous, current) => {
    if (current?.locations.length > 1) {
      // incase the events are multi point
      current.locations.forEach((loc, index) => {
        /* eslint-disable no-param-reassign */
        previous = previous.concat({
          id: index,
          multiEvent: true,
          eventId: current.general.id,
          text: current.general.eventId,
          layer: PAGE_NAME.EVENTS,
          ...getLocation(
            { locations: [loc] },
            undefined,
            handleEventPolygonClick,
          ),
          icon: getEventIcon({
            general: current.general,
            locations: [loc],
          }),
          ...(selectedEvent &&
            selectedEvent.general.id === current.general.id && {
              selectedIcon: true,
            }),
          pageName: current.pageName,
          infoWindowData: {
            // infowindow data
            Title: {
              type: 'text',
              value: current.general.title,
            },
            Category: {
              type: 'text',
              value: current.general.category,
            },
            SeverityRating: {
              type: 'text',
              value: current.general.severityRating,
            },
            Type: {
              type: 'text',
              value: current.general.type,
            },
          },
        });
      });
      return previous;
    }
    return previous.concat({
      id: current.general.id,
      text: current.general.eventId,
      layer: PAGE_NAME.EVENTS,
      ...getLocation(current, undefined, handleEventPolygonClick),
      icon: getEventIcon(current),
      ...(selectedEvent &&
        selectedEvent.general.id === current.general.id && {
          selectedIcon: true,
        }),
      pageName: current.pageName,
      infoWindowData: {
        // infowindow data
        Title: {
          type: 'text',
          value: current.general.title,
        },
        Category: {
          type: 'text',
          value: current.general.category,
        },
        SeverityRating: {
          type: 'text',
          value: current.general.severityRating,
        },
        Type: {
          type: 'text',
          value: current.general.type,
        },
      },
    });
  }, []);
};

const getRole = roles => {
  if (roles.includes(ROLES.SUPERVISOR.id) || roles.includes(ROLES.MANAGER.id)) {
    return ROLES.OPERATOR.name.toLowerCase();
  } else if (roles.length === 1 && roles.includes(ROLES.RESPONDER.id)) {
    return ROLES.RESPONDER.name.toLowerCase();
  } else if (roles.length === 1 && roles.includes(ROLES.GUARD.id)) {
    return ROLES.GUARD.name.toLowerCase();
  } else if (roles.length === 1 && roles.includes(ROLES.MAINTAINER.id)) {
    return ROLES.MAINTAINER.name.toLowerCase();
  } else {
    return roles[0].toLowerCase();
  }
};

export const getOverlayMarkerForPersonnel = data => {
  return {
    id: data.general.id,
    text: data.general.employeeId,
    lat: data?.operational?.location
      ? data.operational.location?.point?.latitude
      : 0,
    lng: data?.operational?.location
      ? data.operational.location?.point?.longitude
      : 0,
    icon: getRole(data.general.roles),
    overlay: true,
    layer: PAGE_NAME.PERSONNEL,
  };
};

export const convertPersonnelToMarkers = (personnels, selectedPersonnel) => {
  return personnels.reduce((previous, current) => {
    if (
      acceptedPersonnelStatus.includes(current.value.operational.status) &&
      current.value.operational.location
    ) {
      return previous.concat({
        id: current.value.general.id,
        pageName: current.pageName,
        text: current.value.general.employeeId,
        name: current.value.general.employeeId,
        lat: current.value.operational.location?.point.latitude,
        lng: current.value.operational.location?.point.longitude,
        layer: PAGE_NAME.PERSONNEL,
        infoWindowData: {
          // infowindow data
          firstName: {
            type: 'text',
            value: current.value.general.firstName,
          },
          LastName: {
            type: 'text',
            value: current.value.general.lastName,
          },
          employeeId: {
            type: 'text',
            value: current.value.general.employeeId,
          },
          status: {
            type: 'text',
            value: current.value.operational.status,
          },
        },
        icon: getRole(current.value.general.roles),
        ...(selectedPersonnel &&
          selectedPersonnel.general.id === current.id && {
            selectedIcon: true,
          }),
      });
    } else {
      return previous;
    }
  }, []);
};
export const getMapIcon = page => {
  switch (page) {
    case PAGE_URLS.WORK_ORDERS.link:
      return TASK_TYPE.MAINTENANCE.mapIcon;
    case PAGE_URLS.SECURITY_TASKS.link:
      return TASK_TYPE.SECURITY.mapIcon;
    default:
      return TASK_TYPE.CLEANING.mapIcon;
  }
};
export const getLayer = page => {
  switch (page) {
    case PAGE_URLS.WORK_ORDERS.link:
      return PAGE_NAME.WORK_ORDER_TASKS;
    case PAGE_URLS.SECURITY_TASKS.link:
      return PAGE_NAME.SECURITY;
    default:
      return PAGE_NAME.CLEANING_TASKS;
  }
};
export const getOverlayMarkerForTask = data => {
  return {
    id: data.others.id.value,
    text: data.others.id.value,
    lat: data.others.surfaceV.value,
    lng: data.others.surfaceU.value,
    icon: getMapIcon(data.others.pageName.value),
    overlay: true,
    layer: getLayer(data.others.pageName.value),
  };
};

const transformPopupData = position => {
  return {
    ...position,
    infoWindowData: {
      TaskName: {
        type: 'text',
        value: position.name,
      },
      taskCategory: {
        type: 'icons',
        value: position.taskCategory,
      },
      siteName: {
        type: 'text',
        value: position.siteName,
      },
      status: {
        type: 'text',
        value: position.status,
      },
    },
  };
};

export const convertTaskToMarkers = (task, selectedTask) => {
  const popupData =
    task &&
    task
      .filter(item => item.surface)
      .map(item => {
        // add InfoWindowData to each point
        const transform = transformPopupData(item);
        return {
          ...transform,
          layer: getLayer(item.pageName),
          lat: transform.surface.lat,
          lng: transform.surface.lng,
          text: transform.surface.text,
          icon: transform.surface.icon,

          ...(!isEmpty(selectedTask) &&
            selectedTask.others.id.value === transform.id && {
              selectedIcon: true,
            }),
        };
      });

  return popupData;
};

export const getOverlayMarkerForEvent = event => {
  return [event].reduce((previous, current) => {
    if (current?.locations.length > 1) {
      // incase the events are multi point
      current.locations.forEach((loc, index) => {
        /* eslint-disable no-param-reassign */
        previous = previous.concat({
          id: index,
          multiEvent: true,
          eventId: current.general.id,
          text: current.general.eventId,
          overlay: true,
          layer: PAGE_NAME.EVENTS,
          ...getLocation({ locations: [loc] }),
          icon: getEventIcon({
            general: current.general,
            locations: [loc],
          }),
        });
      });
      return previous;
    }
    return previous.concat({
      id: current.general.id,
      text: current.general.eventId,
      layer: PAGE_NAME.EVENTS,
      overlay: true,
      ...getLocation(current, event, undefined),
      icon: getEventIcon(event),
    });
  }, []);
};

export const getEventsMarkers = (
  events,
  selectedEvent,
  handleEventPolygonClick,
) => {
  if (!isEmpty(events)) {
    if (!isEmpty(selectedEvent)) {
      return [
        ...convertEventToMarkers({
          events,
          selectedEvent,
          handleEventPolygonClick,
        }),
        ...getOverlayMarkerForEvent(selectedEvent),
      ];
    } else {
      return convertEventToMarkers({ events, handleEventPolygonClick });
    }
  } else {
    return [];
  }
};
export const getPersonnelMarkers = (personnelList, selectedPersonnel) => {
  if (!isEmpty(selectedPersonnel)) {
    return [
      ...convertPersonnelToMarkers(personnelList, selectedPersonnel),
      getOverlayMarkerForPersonnel(selectedPersonnel),
    ];
  } else {
    return !isEmpty(personnelList)
      ? convertPersonnelToMarkers(personnelList)
      : [];
  }
};

export const getTaskMarkers = ({ list, selectedTask }) => {
  if (isEmpty(list)) return [];
  const sanitisedList = list.filter(item => {
    //check if a task has a surface object and doesn't have a surfaceId which shows that the task has an image rather than a geo map
    return (
      item.surface && !item.surfaceId && item.id !== '' && !item.isDummyTask
    );
  });

  if (!isEmpty(selectedTask)) {
    const markers = convertTaskToMarkers(sanitisedList, selectedTask);
    return markers.some(
      item =>
        item.id === selectedTask.others.id.value ||
        //this check is reqd for template task.
        item.id === sanitisedList.filter(task => task.id === item.id)[0].id,
    )
      ? [...markers, getOverlayMarkerForTask(selectedTask)]
      : markers;
  } else {
    return !isEmpty(sanitisedList) ? convertTaskToMarkers(sanitisedList) : [];
  }
};

export const convertToEmergencyMarkers = ({
  personnelList,
  distresses,
  distress,
  acceptedPersonnelStatus,
}) => {
  // return all the markers
  const personnelMarkers = personnelList.reduce((previous, current) => {
    if (
      acceptedPersonnelStatus.includes(current.status) &&
      current.value.operational.location &&
      current.services.includes(serviceTypes.emergency.standard) // anyone with this service should be shown on the map
    ) {
      return previous.concat({
        text: current.value.general.employeeId,
        lat: current.value.operational.location.point.latitude,
        lng: current.value.operational.location.point.longitude,
        icon: getRole(current.value.general.roles),
        layer: PAGE_NAME.EMERGENCY,
        pageName: distress.pageName,
        id: current.id,
      });
    } else {
      return previous;
    }
  }, []);

  // only focus on distress
  if (
    distress.distressee_location &&
    !get(distress, 'general.status.value').startsWith('RESOLVED') // cannot be undefined
  ) {
    let markers = [];
    markers.push({
      lat: distress.distressee_location.latitude,
      lng: distress.distressee_location.longitude,
      icon: `distress-${distress.distressee_role.toLowerCase()}`,
      layer: PAGE_NAME.EMERGENCY,
      pageName: distress.pageName,
    });

    if (distress.responder_location) {
      markers.push({
        lat: distress.responder_location.latitude,
        lng: distress.responder_location.longitude,
        icon: 'distress-responder',
        layer: PAGE_NAME.EMERGENCY,
      });
    } else {
      markers = personnelMarkers.concat(markers);
    }

    return markers;
  }

  const distresseMarkers = distresses.map(distress => ({
    lat: distress.distressee_location.latitude,
    lng: distress.distressee_location.longitude,
    icon: `distress-${distress.distressee_role.toLowerCase()}`,
    pageName: distress.pageName,
    layer: PAGE_NAME.EMERGENCY,
    id: distress.id,
    infoWindowData: {
      CreateAt: {
        type: 'text',
        value: distress.created_at,
      },
      DistresseeName: {
        type: 'icons',
        value: distress.distressee_role.toLowerCase(),
      },
      DistresseeRole: {
        type: 'text',
        value: distress.distressee_role,
      },
      DistresseePhone: {
        type: 'text',
        value: distress.distressee_phone,
      },
    },
  }));

  return personnelMarkers.concat(distresseMarkers);
};

export const convertToEmergencyPolylines = distress => {
  if (
    distress?.others?.distressee_location &&
    !get(distress, 'generalInfo.status.idValue').startsWith('RESOLVED') // cannot be undefined
  ) {
    const markers = [
      {
        lat: distress.others.distressee_location.latitude,
        lng: distress.others.distressee_location.longitude,
      },
    ];
    if (distress.others.responder_location) {
      markers.push({
        lat: distress.others.responder_location.latitude,
        lng: distress.others.responder_location.longitude,
        icon: 'distress-responder',
      });
    }
    return {
      text: `${distress.others.estimatedDistance.value} m`,
      markers: markers,
      dashed: true,
      strokeColor: COLORS.RED,
      layer: PAGE_NAME.EMERGENCY,
    };
  } else {
    return {
      markers: [],
    };
  }
};
export const convertToTripPolylines = trip => {
  if (trip.passengerLocation) {
    const markers = [
      {
        lat: trip.passengerLocation?.value?.latitude,
        lng: trip.passengerLocation?.value?.longitude,
      },
    ];
    if (trip.driverLocation) {
      markers.push({
        lat: trip.driverLocation?.value?.latitude,
        lng: trip.driverLocation?.value?.longitude,
      });
    }
    return {
      // text: `${trip.general.estimatedDistance.value} m`,
      markers: markers,
      dashed: true,
      strokeColor: '#9f9bc8',
    };
  } else {
    return {
      markers: [],
    };
  }
};

export const getOverlayMarkerForTrip = data => {
  return {
    text: data.tripId,
    lat: data.latitude,
    lng: data.longitude,
    icon: 'PASSENGER_NORMAL',
    overlay: true,
  };
};

export const convertTripToMarkers = (trip, selectedTrip) => {
  return trip.reduce((previous, current) => {
    if (!current.status.startsWith('RESOLVED') && current.pickUpLocation) {
      return previous.concat({
        id: current.id,
        text: current.tripId,
        lat: current.pickUpLocation?.latitude,
        lng: current.pickUpLocation?.longitude,
        icon: 'PASSENGER_NORMAL',
        layer: PAGE_NAME.TRANSPORT_OPERATIONAL,
        pageName: current.pageName,
        infoWindowData: {
          // infowindow data
          driver: {
            type: 'text',
            value: current.driver,
          },
          estimatedPrice: {
            type: 'text',
            value: current.estimatedPrice,
          },
          passenger: {
            type: 'text',
            value: current.passenger,
          },
          pickUpPoint: {
            type: 'text',
            value: current.pickUpPoint,
          },
        },
        ...(selectedTrip &&
          selectedTrip.others.id.value === current.id && {
            selectedIcon: true,
          }),
      });
    } else {
      return previous;
    }
  }, []);
};

export const getTripMarkers = (trip, selectedTrip) => {
  if (!isEmpty(selectedTrip)) {
    const markers = convertTripToMarkers(trip, selectedTrip);
    return markers.some(item => item.id === selectedTrip.others.id.value)
      ? [...markers, getOverlayMarkerForTrip(selectedTrip)]
      : markers;
  } else {
    return !isEmpty(trip) ? convertTripToMarkers(trip) : [];
  }
};
